'use strict';

angular.module('contentful')
.directive('cfNewOrganizationMembership', ['require', require => {
  var controller = require('account/NewOrganizationMembership').default;

  return {
    template: '<cf-component-bridge component="component">',
    scope: {
      properties: '='
    },
    controller: ['$scope', controller]
  };
}]);



// WEBPACK FOOTER //
// ./src/javascripts/account/cf_new_organization_membership.js